import { module as modujs } from "modujs";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class extends modujs {
	constructor(m) {
		super(m);
		this.handleMove = this.handleMove.bind(this);
		this.handleLeave = this.handleLeave.bind(this);
	}

	init() {
		this.ring = this.el.querySelector(".js-ring");
		this.svg = this.el.querySelector(".js-svg");
		if (!this.ring || !this.svg) return;

		// Base 3D
		gsap.set(this.el, { perspective: 900 });
		gsap.set(this.ring, { transformStyle: "preserve-3d", rotateX: 55, rotateY: 0 });

		// Rotation continue du texte
		this.spin = gsap.to(this.svg, {
			rotation: 360,
			duration: 12,
			ease: "none",
			repeat: -1,
			paused: true,
		});

		ScrollTrigger.create({
			trigger: this.el,
			start: "top 80%",
			end: "bottom top",
			onEnter: () => this.spin.play(),
			onEnterBack: () => this.spin.play(),
			onLeave: () => this.spin.pause(),
			onLeaveBack: () => this.spin.pause(),
		});

		// --- Curseur personnalisé ---
		this.cursor = document.createElement("div");
		this.cursor.classList.add("c-ring3d_cursor");
		document.body.appendChild(this.cursor);

		this.el.addEventListener("mousemove", this.handleMove);
		this.el.addEventListener("mouseleave", this.handleLeave);
	}

	handleMove(e) {
		const rect = this.el.getBoundingClientRect();
		const x = (e.clientX - rect.left) / rect.width - 0.5;
		const y = (e.clientY - rect.top) / rect.height - 0.5;

		// rotation du ring
		gsap.to(this.ring, {
			rotateX: 55 - y * 30,
			rotateY: x * 30,
			duration: 0.4,
			ease: "power2.out",
		});

		// déplace le curseur centré sur le pointeur
		gsap.to(this.cursor, {
			x: e.clientX - 24, // décalage horizontal = moitié de la largeur
			y: e.clientY - 24, // décalage vertical = moitié de la hauteur
			duration: 0.15,
			ease: "power2.out",
			opacity: 1,
			scale: 1,
		});
	}

	handleLeave() {
		gsap.to(this.ring, {
			rotateX: 55,
			rotateY: 0,
			duration: 0.8,
			ease: "power3.out",
		});

		// disparition douce du curseur
		gsap.to(this.cursor, {
			opacity: 0,
			scale: 0.6,
			duration: 0.3,
			ease: "power1.out",
		});
	}

	destroy() {
		this.el.removeEventListener("mousemove", this.handleMove);
		this.el.removeEventListener("mouseleave", this.handleLeave);
		this.cursor.remove();
		gsap.killTweensOf([this.svg, this.ring, this.cursor]);
	}
}
